import { render, staticRenderFns } from "./Hxpgl.vue?vue&type=template&id=0eddfd4a&scoped=true&"
import script from "./Hxpgl.vue?vue&type=script&lang=js&"
export * from "./Hxpgl.vue?vue&type=script&lang=js&"
import style0 from "./Hxpgl.vue?vue&type=style&index=0&id=0eddfd4a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eddfd4a",
  null
  
)

export default component.exports